export const getResult = ({ requests: { result } }) => result
